import React from "react";


const LRS_LOGO_DARK_SURFACE  = "/Assets/LRS_Logo_Full_Alt_PNG.png";
const LRS_LOGO_LIGHT_SURFACE = "/Assets/LRS_Logo_Full_PNG.png";


export default function Logo({ variant = "nav", brand = "lrs" }) {
    const alt = "London Renovation Specialists";
    const src = variant === "login" ? LRS_LOGO_LIGHT_SURFACE : LRS_LOGO_DARK_SURFACE;
    const cls =
        variant === "footer" ? "block h-11 w-auto" :
        variant === "login"  ? "block h-14 w-auto mx-auto" :
                               "block h-[38px] md:h-12 w-auto";
    return <img src={src} alt={alt} className={cls}
                data-testid={`lrs-logo-${variant}`} />;
}
